import config from '@/services/config'
import axios from 'axios'

const servicioBase = axios.create(
    {
        baseURL: config.apiUrl
    })
    export default servicioBase;